interface GetPercentSymbolOptions {
  includeSpacing: boolean
}

export const getPercentSymbol = (
  localeCode: string,
  options: GetPercentSymbolOptions = {
    includeSpacing: false,
  }
): string => {
  const percentSymbol: string = Intl.NumberFormat(localeCode, {
    style: "percent",
  })
    .formatToParts(0)
    .filter((part) => {
      // Include any spacing that is part of the currency symbol display
      if (options.includeSpacing) {
        return part.type === "percentSign" || part.type === "literal"
      } else {
        return part.type === "percentSign"
      }
    })
    .map((part) => part.value)
    .join("")

  return percentSymbol
}
